import { UserGroupClient } from '@frontend/group/api';
import { GroupMember, IGroup } from '@frontend/group/types';
import { useModals } from '@frontend/modal';
import { useEffect, useState } from 'react';

import type { UserGroupCardProps } from './user-group-card.component';

export const useUserGroupCard = (props: UserGroupCardProps) => {
    const { openModal } = useModals();
    const [groups, setGroups] = useState<IGroup[]>([]);
    const [members, setMembers] = useState<GroupMember[]>([]);

    const fetchGroups = async () => {
        UserGroupClient.fetchUserGroupMembers({ entity_id: props.entity_id }).then((members) => {
            setMembers(members.results);
            const groupPromises = members.results.map((member) => UserGroupClient.fetchUserGroup(member.account_id, member.group_id).then((group) => group));
            Promise.all(groupPromises).then((fetchedGroups) => {
                setGroups(fetchedGroups);
            });
        });
    };

    useEffect(() => {
        fetchGroups();
    }, [props.entity_id]);

    return {
        openModal,
        groups,
        members,
        fetchGroups
    };
};
